'use client';

import { ReactNode } from 'react';
import { useLogoutDialog } from './LogoutDialogProviderClient';
import { clsx } from 'clsx';

export const LogoutDialogButton = ({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) => {
  const { open } = useLogoutDialog();

  return (
    <button className={clsx('cursor-pointer', className)} onClick={open}>
      {children}
    </button>
  );
};
